<template>
  <div class="step-section">
    <h2>Step Five: Generate order forms</h2>
    <p>
      When you're happy with the above choices, hit <button @click="generatePDF">Generate Orders</button> to create your pathology forms.
    </p>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import LongDate from './LongDate.vue'

export default {
  name: 'StepFive',
  components: { LongDate },
  props: ['dates', 'orders', 'patients', 'userDetails'],
  methods: {
    getPatientWithID(id) {
      for (const index in this.patients) {
        if (this.patients[index].id == id) {
          return this.patients[index]
        }
      }
    },
    generatePDF() {
      const doc = new jsPDF();

      var xAlign = 10;

      doc.setFont("helvetica")
      doc.setFontSize(20)
      doc.text("Pathology Order Summary:", xAlign, 10);

      var currentX = 0
      var currentY = 15
      var xElementSpacing = 25
      var yElementSpacing = 10

      // Draw date headings
      doc.setFontSize(10)
      this.dates.forEach((date) => {
        currentX = currentX + xElementSpacing
        doc.text(date, xAlign + currentX, currentY +4);
        doc.line(currentX +7, currentY +6, currentX +7, currentY +6 +this.patients.length * yElementSpacing)
      })
      doc.line(currentX +7 +xElementSpacing, currentY +6, currentX +7 +xElementSpacing, currentY +6 +this.patients.length * yElementSpacing)

      // Draw patients and their tests
      this.patients.forEach((patient) => {
        currentY = currentY + yElementSpacing
        currentX = xAlign;

        if (patient.id in this.orders) {

          doc.setFontSize(8)
          doc.text(patient.lastName + ", " + patient.firstName, xAlign -5, currentY);
          doc.text("("+patient.id+")", xAlign -5, currentY + 4);
          doc.line(xAlign -5, currentY +6, 32 + this.dates.length * xElementSpacing, currentY +6)

          doc.setFontSize(6)
          this.dates.forEach((date) => {
            currentX = currentX +xElementSpacing
            if(patient.id in this.orders) {
              if (date in this.orders[patient.id]) {
                var yOffset = -1
                this.orders[patient.id][date].forEach((test) => {
                  doc.text(test, currentX +xElementSpacing/2 -3, currentY+yOffset, 'center');
                  yOffset +=2
                })
              }
            }
          })
        }
      })

      // Generate pathology forms
      for (const patientID in this.orders){
        for (const patientOrderDate in this.orders[patientID]) {
            if (this.orders[patientID][patientOrderDate].length > 0) {
              doc.addPage()
              doc.setFontSize(8)
              doc.text("To prevent Medicare fraud, this demo version of Weekend does not actually generate the pathology requests.", 10, 10);
              doc.text("Instead, it simply demonstrates that I can print all of the relevant patient / test details onto a blank page.", 10, 13);
              doc.text("In real life, this blank page would in fact be a pathology request form.", 10, 16);

              doc.setFontSize(14)

              var patient = this.getPatientWithID(patientID)
              doc.text(patient.firstName + " " + patient.lastName + " (" + patient.id+ ")", 10, 24)

              doc.setFontSize(12)
              doc.text("Tests requested:", 10, 32);
              this.orders[patientID][patientOrderDate].forEach((test, index) => {
                doc.text(test, 10, 32 + (index +1) * 4);
              })

              doc.text("Request date:", 46, 32);
              doc.text(patientOrderDate, 46, 38);

              doc.text("Requested by:", 80, 32);
              doc.text(this.userDetails.firstName + " " + this.userDetails.lastName, 80, 38);
              doc.text("Provider " + this.userDetails.providerNumber, 80, 44);
              doc.text("Auslab Code " + this.userDetails.auslabCode, 80, 50);
            }
        }
      }
      
      doc.save("weekend.pdf");
    }
  }
}
</script>

<style>

</style>
